import withMediaQuery from './withMediaQuery';
import { TABLET } from '../../style/common/breakpoints';

export default function withMatchesTablet(Component) {
  return withMediaQuery(TABLET)(Component);
}



// WEBPACK FOOTER //
// ./src/app/ui/core/common/withMatchesTablet.js